import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { categoriesArrayPropTypes } from 'helpers/propTypes';

import './Footer.scss';
import FooterTextil from './FooterTextil';
import FooterD5 from './FooterD5';
import FooterD7 from './FooterD7';

const Footer = (props) => {
  const { marcasHome, subCategoriesHome, client } = props;

  switch (client?.design) {
    case 3:
      return (
        <FooterTextil
          marcasHome={marcasHome}
          subCategoriesHome={subCategoriesHome}
          client={client}
        />
      )

    case 5:
      return (
        <FooterD5
          marcasHome={marcasHome}
          subCategoriesHome={subCategoriesHome}
          client={client}
        />
      )

    case 6:
      return (
        <FooterD5
          marcasHome={marcasHome}
          subCategoriesHome={subCategoriesHome}
          client={client}
        />
      )
    case 7:
      return (
        <FooterD7
          marcasHome={marcasHome}
          subCategoriesHome={subCategoriesHome}
          client={client}
        />
      )

    default:
      return (
        <FooterD5
          marcasHome={marcasHome}
          subCategoriesHome={subCategoriesHome}
          client={client}
        />
      );
  }
};

const mapStateToProps = (state) => ({
  marcasHome: state.category.marcasHome,
  subCategoriesHome: state.subCategory.itemsHome,
  client: state.app.client,
});

Footer.propTypes = {
  marcasHome: categoriesArrayPropTypes.isRequired,
  subCategoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default connect(mapStateToProps)(Footer);
